import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Typography, Box } from "@mui/material";

import { LineSkeleton } from "components/formFields/LineSkeleton";
import { Link } from "components/html/Link";

import { i18n } from "services/i18nService";
import { getPlans } from "services/sosInventoryService/sosApi";

import { PlanCard } from "views/Trial/PlanCard";

export function PlanSelection() {
  const [plans, setPlans] = useState(null);

  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === "/trialsignup") {
      navigate(`/planselection${search}`, { replace: true });
    }
  }, [pathname, navigate, search]);

  useEffect(() => {
    async function _getAccountInformation() {
      const { success, data } = await getPlans();
      if (success) {
        setPlans(data);
      }
    }
    _getAccountInformation();
  }, []);

  return (
    <>
      <Box sx={{ m: "2rem 4rem" }}>
        <Typography sx={{ mb: 1 }} variant="h3">
          {i18n("trial.SelectPlan")}
        </Typography>
        <Box>
          <Typography component="span">
            {i18n("trial.ClickButtonGetStarted.1")}
          </Typography>{" "}
          <Link
            component="a"
            rel="noreferrer"
            href="https://www.sosinventory.com/features"
            target="_blank"
          >
            {i18n("trial.ClickButtonGetStarted.2")}
          </Link>
          <Box sx={{ display: "flex", justifyContent: "space-evenly", mt: 4 }}>
            {plans ? (
              plans.map(
                (
                  {
                    name,
                    priceMonthly,
                    priceAnnual,
                    userLimit,
                    extraUserMonthly,
                  },
                  i
                ) => (
                  <PlanCard
                    key={i}
                    name={name}
                    priceMonthly={priceMonthly}
                    priceAnnual={priceAnnual}
                    userLimit={userLimit}
                    extraUserMonthly={extraUserMonthly}
                    search={search}
                  />
                )
              )
            ) : (
              <>
                <LineSkeleton sx={{ width: "20rem", minHeight: "8rem" }} />
                <LineSkeleton sx={{ width: "20rem", minHeight: "8rem" }} />
                <LineSkeleton sx={{ width: "20rem", minHeight: "8rem" }} />
              </>
            )}
          </Box>
          <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
            <Typography component="div" variant="subheader">
              {i18n("trial.SubTitle")}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
